import React, { useContext } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import ShoppingContext from '../../context/shoping/shoppingContext';

const FreeShopping = () => {
  const shoppingContext = useContext(ShoppingContext);

  const { freeShipping } = shoppingContext;

  return (
    <Container className='LiveThrowdown p-0' fluid>
      <TopNav />
      <Container className='text-light'>
        <h2 className='text-capitalize'>shopping cart</h2>
        <h4>{freeShipping.length}items</h4>
        <Row className='my-5 freeShipping_main'>
          <Col xl={8}>
            {freeShipping.map((shopping) => (
              <div key={shopping.id}>
                <Row>
                  <Col md={8} className='d-flex'>
                    <div className=' shopping-img'>{shopping.image}</div>
                    <div className='pl-4'>
                      <div>{shopping.heading}</div>

                      <div className='my-4'>
                        <p className='m-0 pl-1'>Quantity</p>
                        <button className='btn border border-light text-light'>
                          <i className='fa fa-minus' aria-hidden='true'></i> num{' '}
                          <i className='fa fa-plus' aria-hidden='true'></i>
                        </button>
                      </div>
                      <div className='my-4'>
                        <p className='m-0'>Size</p>
                        <button className='btn border border-light text-light'>
                          xs{' '}
                          <i
                            className='fa fa-angle-down'
                            aria-hidden='true'
                          ></i>
                        </button>
                      </div>
                    </div>
                  </Col>
                  <Col className='d-flex ml-5'>
                    <div>{shopping.price}</div>
                    <div className='ml-auto'>
                      <i
                        className='fa fa-trash text-light'
                        aria-hidden='true'
                      ></i>
                    </div>
                  </Col>
                </Row>
                <div className='divider-white'></div>
              </div>
            ))}
          </Col>

          <Col md={4} className=' price_cart-position px-5'>
            <div className='price_cart_box p-4 '>
              <div className=' mb-4 text-capitalize'>price details</div>
              <div className='d-flex  my-3'>
                <div>Shopping Cart</div>
                <div className='ml-auto'>₹ 9,418</div>
              </div>
              <div className='d-flex  my-3'>
                <div>Shipping</div>
                <div className='ml-auto'>Free</div>
              </div>{' '}
              <div className='d-flex  mt-5'>
                <div>Total</div>
                <div className='ml-auto text-strong'>₹ 9,418</div>
              </div>
              <div className='d-flex mt-3'>
                <button className='btn btn-black ml-auto text-capitalize'>
                  place order
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
export default FreeShopping;
